import { Badge } from '@mantine/core';
import type { MatchingSessionStatus } from '../../../../services/api/matchingSessions';

interface StatusConfig {
  label: string;
  color: string;
}

const STATUS_CONFIG: Record<MatchingSessionStatus, StatusConfig> = {
  submitting: { label: 'Starting', color: 'gray' },
  ready: { label: 'Ready', color: 'blue' },
  in_progress: { label: 'In Progress', color: 'warningAmber' },
  awaiting_finalize: { label: 'Awaiting Finalize', color: 'warningAmber' },
  completed: { label: 'Completed', color: 'medleyGreen' },
  failed: { label: 'Failed', color: 'dangerRed' },
  expired: { label: 'Expired', color: 'gray' },
};

interface StatusBadgeProps {
  status: MatchingSessionStatus;
}

/**
 * Status pill for matching session rows (MED-829 / E23-8 AC8).
 * Uses Medley Design System theme colors (medleyGreen, warningAmber, dangerRed).
 * Style: uppercase 10px text with 0.3px letter-spacing per the Style Guide.
 */
export function StatusBadge({ status }: StatusBadgeProps) {
  const config = STATUS_CONFIG[status];
  return (
    <Badge
      color={config.color}
      variant="light"
      size="sm"
      tt="uppercase"
      styles={{
        label: {
          fontSize: 10,
          letterSpacing: '0.3px',
          fontWeight: 600,
        },
      }}
    >
      {config.label}
    </Badge>
  );
}
